import * as React from "react";
import * as moment from 'moment';
import NavBar from "../components/NavBar";
import { Modal, Table, Button, ButtonToolbar } from "react-bootstrap";
import { LinkContainer, IndexLinkContainer } from "react-router-bootstrap";
import { RouteChildrenProps } from "react-router";
import AppUser from "../AppUser";
import { firestore, storage } from "firebase";
import * as fs from "../firestore";
import firebase from "../firebase";
import { dataItem } from "./DemoDataImportFunc"

interface State {
    csv: string;
    dataItem: dataItem[];
}

interface Props extends RouteChildrenProps {
    user: AppUser
}

export default class DemoDataImportPage extends React.Component<Props, State, {}> {
    private onClickCSVImportBound: () => void;
    private file!: HTMLInputElement;


    constructor(props: Props) {
        super(props);
        this.onClickCSVImportBound = this.onClickCSVImport.bind(this);

        this.state = {
            csv: '',
            dataItem: []
        };
    }

    readFileAsText(file: Blob): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = () => reject(reader.error);
            reader.onload = () => resolve((reader.result as string) || '');
            reader.readAsText(file);
        });
    }

    getBoolean( flag: string ): boolean {
        var chkFlag = false;
        if ( flag === "TRUE" ) {
            chkFlag = true;
        }
        return chkFlag;
    }

    mapArrayTodataItem(data: string[][]): dataItem[] {
        return data
            .map((row) => {
                return {
                    samplingNo: row[0],
                    samplingDateTime: row[1],
                    samplingLatitude: Number(row[2]),
                    samplingLongitude: Number(row[3]),
                    samplingImage: row[4],
                    scomment: row[5],
                    fieldName: row[6],
                    cropName: row[7],
                    ssoilTypeIndex: Number(row[8]),
                    screateDateTime: row[9],
                    supdateDateTime: row[10],
                    suserRef: row[11],
                    sdeleteFlag: this.getBoolean(row[12]),
                    scopeId: row[13],
                    analysisId: Number(row[14]),
                    analysisName: row[15],
                    analysisDateTime: row[16],
                    dilutionRate: Number(row[17]),
                    asoilTypeIndex: Number(row[18]),
                    absorbance1: Number(row[19]),
                    absorbance2: Number(row[20]),
                    absorbance3: Number(row[21]),
                    absorbance4: Number(row[22]),
                    absorbance5: Number(row[23]),
                    absorbanceAvg: Number(row[24]),
                    concentration1: Number(row[25]),
                    concentration2: Number(row[26]),
                    concentration3: Number(row[27]),
                    concentration4: Number(row[28]),
                    concentration5: Number(row[29]),
                    concentrationAvg: Number(row[30]),
                    concentrationValue: Number(row[31]),
                    brayValue: Number(row[32]),
                    truogValue: Number(row[33]),
                    acomment: row[34],
                    acreateDateTime: row[35],
                    aupdateDateTime: row[36],
                    auserRef: row[37],
                    adeleteFlag: this.getBoolean(row[38]),
                    samplingResultRef: firestore().collection(fs.Collection.SamplingResults).doc(row[39]),
                    takenDateTime: row[40],
                    analysisImage: row[41],
                    analysisPointX: Number(row[42]),
                    analysisPointY: Number(row[43])
                };
            })  
    }   

    mapCSVToArray(csv: string): string[][] {
        return csv.split('\n').map((row) => row.split(','));
    }   

    async getCSV(file: Blob): Promise<string>{
        try {
            const csv = await this.readFileAsText(file);
            this.setState({
                csv: csv
            })
            return csv;
        } catch (error) {
            this.setState({
                csv: ''
            })
            return "";
        }
    }

    setSamplingData(dataItems: dataItem[]): boolean {
        const SamplingAddRef = firestore().collection(fs.Collection.SamplingResults);
        var addState = true;
        dataItems.forEach( function(value, index) {
            const addSample = SamplingAddRef
                .add({
                    "samplingNo": value.samplingNo,
                    "samplingDateTime": new Date(value.samplingDateTime),
                    "samplingLatitude": value.samplingLatitude,
                    "samplingLongitude": value.samplingLongitude,
                    "samplingImage": value.samplingImage,
                    "comment": value.scomment,
                    "fieldName": value.fieldName,
                    "cropName": value.cropName,
                    "soilTypeIndex": value.ssoilTypeIndex,
                    "createDateTime": new Date(value.screateDateTime),
                    "updateDateTime": new Date(value.supdateDateTime),
                    "userRef": firestore().collection(fs.Collection.Users).doc(value.suserRef),
                    "deleteFlag": value.sdeleteFlag
            })
            .then(function(docRef) {
                dataItems[index].samplingResultRef = docRef
            })
            .catch(function(error) {
                alert("Import Error Sampling Data")
                addState = false;
            });
        })
        return addState;
    }

    setAnalysisData(dataItems: dataItem[]): boolean {
        const AnalisysAddRef = firestore().collection(fs.Collection.AnalysisResults);
        dataItems.forEach( function(value, index) {
            var addAnalysis = AnalisysAddRef
                .add ({
                    "scopeId": value.scopeId,
                    "analysisId": value.analysisId,
                    "analysisName": value.analysisName,
                    "analysisDateTime": new Date(value.analysisDateTime),
                    "dilutionRate": value.dilutionRate,
                    "soilTypeIndex": value.asoilTypeIndex,
                    "absorbance1": value.absorbance1,
                    "absorbance2": value.absorbance2,
                    "absorbance3": value.absorbance3,
                    "absorbance4": value.absorbance4,
                    "absorbance5": value.absorbance5,
                    "absorbanceAvg": value.absorbanceAvg,
                    "concentration1": value.concentration1,
                    "concentration2": value.concentration2,
                    "concentration3": value.concentration3,
                    "concentration4": value.concentration4,
                    "concentration5": value.concentration5,
                    "concentrationAvg": value.concentrationAvg,
                    "concentrationValue": value.concentrationValue,
                    "brayValue": value.brayValue,
                    "truogValue": value.truogValue,
                    "comment": value.acomment,
                    "createDateTime": new Date(value.acreateDateTime),
                    "updateDateTime": new Date(value.aupdateDateTime),
                    "userRef": firestore().collection("users").doc(value.suserRef),
                    "deleteFlag": value.adeleteFlag,
                    "samplingResultRef": value.samplingResultRef,
                    "takenDateTime": new Date(value.takenDateTime),
                    "analysisImage": value.analysisImage,
                    "analysisPointX": value.analysisPointX,
                    "analysisPointY": value.analysisPointY,
            })
            .then(
            )
            .catch(function(error) {
                alert("Import Error Analysis Data")
                return false;
            });
        })
        return true;
    }

    chkdataItem(dataItems: dataItem[]): string {
        var chkState = "";
        dataItems.forEach( function(value, index) {
            if ( value.samplingNo !== "" ) {
                chkState = "Sampling";
            }
            if ( value.scopeId !== "" ) {
                chkState = "Analysis";
            }
        });
        return chkState;
    }

    async onClickCSVImport() {
        if (!this.file.files || !this.file.files[0]) {
            return;
        }
        const r = await this.getCSV(this.file.files[0]);
        const arr = this.mapCSVToArray(this.state.csv);
        const dataItems = this.mapArrayTodataItem(arr);
        const chk = this.chkdataItem(dataItems);
        if ( chk === "Sampling" ) {
            const s = this.setSamplingData(dataItems);
            if (s) {
                alert("Sampling Data Import Finished")
            }
        }
        if ( chk === "Analysis" ) {
            const r = this.setAnalysisData(dataItems);
            if (r) {
                alert("Analysis Data Import Finished")
            }
        }
    }

    render() {
        return (
            <div>
                <NavBar {...this.props}/>
                <div className="import_main">
                    <p>CSVファイルを選択してください</p>
                    <input
                        type="file"
                        className="file"
                        ref={(file: HTMLInputElement) => (this.file = file)}
                        accept="text/csv"
                    />
                    <button className="read-button" onClick={this.onClickCSVImportBound}>取込</button>
                </div>
            </div>
        );
    }
}
